import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
import ProductsView from './views/ProductsView.vue';
import ProductDetailView from './views/ProductDetailView.vue';
import ArticlesView from './views/ArticlesView.vue';
import CompanyLayout from './views/CompanyLayout.vue';
import CompanyView from './views/CompanyView.vue';
import FactoryView from './views/FactoryView.vue';
import PageView from './views/PageView.vue';
import QualityView from './views/QualityView.vue';
import ContactView from './views/ContactView.vue';
import { recordVisit } from './api';
import { locale } from './i18n';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: (to, from, savedPosition) => {
    // 分类、搜索和同页阅读层只更新 query，保留当前阅读位置。只有真正进入
    // 另一页面时才回到顶部；浏览器前进/后退仍优先恢复其原有滚动位置。
    if (to.path === from.path) return false;
    return savedPosition || { top: 0 };
  },
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/products', name: 'products', component: ProductsView },
    { path: '/products/:slug', name: 'product-detail', component: ProductDetailView },
    { path: '/news', name: 'news', component: ArticlesView, meta: { type: 'news' } },
    { path: '/news/:slug', redirect: (to) => ({ name: 'news', query: { ...to.query, article: String(to.params.slug) } }) },
    { path: '/cases', name: 'cases', component: ArticlesView, meta: { type: 'case' } },
    { path: '/cases/:slug', redirect: (to) => ({ name: 'cases', query: { ...to.query, article: String(to.params.slug) } }) },
    {
      path: '/company',
      component: CompanyLayout,
      children: [
        { path: 'company', name: 'company', component: CompanyView },
        { path: 'factory', name: 'factory', component: FactoryView },
        { path: 'quality', name: 'quality', component: QualityView }
      ]
    },
    { path: '/company/contact', redirect: '/contact' },
    { path: '/company/:slug', name: 'page', component: PageView },
    { path: '/contact', name: 'contact', component: ContactView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
});

router.afterEach((to) => {
  recordVisit({
    path: to.fullPath,
    referrer: document.referrer || null,
    locale: locale.value
  });
});
